import { Component } from '@angular/core';
import { ProgressBarStatus } from '@maced/angular-components/lib/progress-bar/progress-bar.model';

@Component({
  selector: 'app-progressbar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent {
  statusList: ProgressBarStatus[] = [
    'success', 'danger', 'default'
  ];
  selectedStatus: ProgressBarStatus = 'success';
  languages: string[] = [
    'English', 'Spanish', 'Hindi'
  ];
  selectedLanguage: string = 'English';
  valueList: number[] = [
    10, 30, 50, 80, 100
  ];
  selectedValue: number = 10;

  getLabel() {
    if (this.selectedLanguage === 'English') {
      return 'Download Progress';
    } else if (this.selectedLanguage === 'Spanish') {
      return 'Progreso de descarga';
    } else {
      return 'डाउनलोड प्रगति';
    }
  }
}